import React from "react";
import Layout from "../components/Layout";
import { useLanguage } from "../i18n/LanguageContext";
import "../styles/About.css";

function About() {
  const { t } = useLanguage();

  return (
    <Layout>
      <section className="panel about-panel">
        <h1>{t.about.title}</h1>
        {t.about.paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </section>
    </Layout>
  );
}

export default About;
